/**
 * accordion.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import {preventDefault} from "ol/events/Event";
import {display} from "@splidejs/splide/src/js/utils";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.accordion = {
    attach: function (context, settings) {

      once('accordion-expand-all', '.bp-accordion-button', context).forEach(
        function (element) {
            $(element).click(function(){
                $(element).closest('.paragraph--bp-accordion-container').find('.card-block').addClass('show');
                $(element).closest('.paragraph--bp-accordion-container').find('.card-header').removeClass('collapsed');
            });
          $(element).closest('.paragraph--bp-accordion-container').find('.saipem--text-container').removeClass('col-md-8').addClass('col-md-12');
        }
      );
    }
  };




})(jQuery, Drupal, drupalSettings);
